export const getValidationErrors = (error) => {
	if (!error || !Array.isArray(error.body)) return [];
	return error.body;
};

export const getFieldErrors = (error) => {
	const errors = getValidationErrors(error);
	const result = {};
	for (const item of errors) {
		if (item.location === "body") {
			result[item.name] = item.description;
		}
	}
	return result;
};
